export enum SynapsVerificationStatus {
	PENDING_VERIFICATION = "PENDING_VERIFICATION",
	APPROVED = "APPROVED",
	SUBMISSION_REQUIRED = "SUBMISSION_REQUIRED",
	RESUBMISSION_REQUIRED = "RESUBMISSION_REQUIRED",
	REJECTED = "REJECTED",
	RESET = "RESET",
}
